// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

const ImageTag = styled.img`
  width: ${(props) => (props.isQuickView ? `100%` : `50%`)};
  margin: 10px 0;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    width: 100%;
  }
`;

export default ImageTag;
